import getApiClient from '@/plugins/api-client'

export default {
    load() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('frequently_asked_questions')
            .then(result => {
                self.questions = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },

    showDeleteConfirmation(id) {
        this.deleteQuestion = id

        this.showDeleteConfirmationModal = true
    },

    deleteModal() {
        const self = this,
            api = getApiClient(self.$store),
            id = self.deleteQuestion

        api.delete(`frequently_asked_questions/${id}`)
            .then(() => {
                self.deleteQuestion = null
                let question = self.questions.filter(question => {
                    return question.id === id
                })

                self.load()
                self.showDeleteConfirmationModal = false
            })
            .catch(error => {
                console.log(error)
            })
    },

    cancelDeleteModal() {
        this.deleteQuestion = null
        this.showDeleteConfirmationModal = false
    },

    goToEdit(id) {
        this.$router.push(`/frequently_asked_questions/edit/${id}`)
    },

    updateSorting() {
        const self = this,
            api = getApiClient(self.$store)

        let payload = {
            questions: []
        }

        self.questions.forEach((question, index) => {
            question.weight = index

            payload.questions.push({
                id: question.id,
                weight: index
            })
        })

        self.sortingChanged = false

        api.post('frequently_asked_questions/sort', payload)
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                self.load()
            })
    }
}
